module.exports = __webpack_public_path__ + "static/img/sports.af71048.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ribenurl/sports.jpg
// module id = huD/
// module chunks = 23